export default "__VITE_ASSET__GmBZMLIL__"